import styled from '@emotion/styled'
// @ts-ignore
interface ExtendedTheme extends Theme {
  width?: string
}
export const TableWrapper = styled.table<{ theme?: ExtendedTheme }>`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px;

  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      max-width: 805px;
    }
  }

  tr {
    height: 30px;
  }

  th {
    background-color: #e7f1fd;
    text-align: left;
    padding: 3px 10px;
    border-right: none;
    width: 160px;
    border-top: 1px solid #d4d8dd;
    //border-left: 1px solid #d4d8dd;
  }

  td {
    max-width: 545px;
    background-color: #ffffff;
    padding: 3px 10px;
    border-left: none;
    border-top: 1px solid #d4d8dd;
    border-right: 1px solid #d4d8dd;
  }

  tr:first-of-type {
    th:first-of-type {
      border-top-left-radius: 4px;
      border-left: 1px solid #d4d8dd;
    }

    td:last-of-type {
      border-top-right-radius: 4px;
    }
  }

  tr:last-of-type {
    th:first-of-type {
      border-bottom-left-radius: 4px;
      border-bottom: 1px solid #d4d8dd;
      border-left: 1px solid #d4d8dd;
    }

    td:last-of-type {
      border-bottom-right-radius: 4px;
      border-bottom: 1px solid #d4d8dd;
    }
  }

  tr:last-of-type th,
  tr:last-of-type td {
    border-bottom: 1px solid #d4d8dd;
  }

  tr td:first-of-type {
    border-right: none;
    width: ${props => props?.theme?.width};
  }
`
// @ts-ignore
TableWrapper.defaultProps = {
  theme: { width: '326px' },
}
